import { RecordType, type TemplateRecord } from '@wiztime/core';
import { assertWithinDay } from './placement';
import type { WriteSession } from './session';

export interface TemplateInput {
  /** Omit to create a new template. */
  readonly id?: string;
  readonly projectId: string;
  readonly startMin: number;
  readonly endMin: number;
}

/** Create or update a draft template (a fixed time slot that generates a draft each day). */
export async function upsertTemplate(session: WriteSession, input: TemplateInput): Promise<TemplateRecord> {
  assertWithinDay(input, await session.settings());
  await session.requireProject(input.projectId);
  return session.write(RecordType.Template, input.id ?? session.newId(), {
    projectId: input.projectId,
    startMin: input.startMin,
    endMin: input.endMin,
  });
}

export async function deleteTemplate(session: WriteSession, id: string): Promise<void> {
  await session.require(RecordType.Template, id);
  await session.write(RecordType.Template, id, null);
}
